import whenDomReady from 'when-dom-ready';
function initialise() {
    const logoGrid = document.querySelector('.js-logo-grid');
    if (!logoGrid)
        return;
    const images = logoGrid.querySelectorAll('.logo-grid__image');
    if (!images || images.length === 0)
        return;
    const hiddenDiv = document.getElementById('hiddenImageUrls');
    if (!hiddenDiv)
        return;
    const cirleImagesPause = parseInt(hiddenDiv.dataset.pause || '0', 0); // Default value set in widget properties
    if (cirleImagesPause > 0) {
        const allUrls = hiddenDiv.dataset.urls?.split(';') || [];
        const allAlts = hiddenDiv.dataset.alts?.split(';') || [];
        const visibleCount = images.length;
        if (allUrls.length < visibleCount || allAlts.length < visibleCount)
            return;
        let currentIndex = visibleCount;
        let activeImageIndex = 0;
        setInterval(() => {
            const image = images[activeImageIndex];
            // Start fade-out
            image.classList.add('fade-out');
            setTimeout(() => {
                // Update image source and alt
                image.src = allUrls[currentIndex];
                image.alt = allAlts[currentIndex];
                // Fade back in
                image.classList.remove('fade-out');
                // Move to next image in visible list
                activeImageIndex = (activeImageIndex + 1) % visibleCount;
                // Move to next image in full list
                currentIndex = (currentIndex + 1) % allUrls.length;
            }, 500); // Match CSS transition duration
        }, cirleImagesPause);
    }
}
whenDomReady().then(initialise);
